import { Skeleton } from "~/components/ui/skeleton";

/**
 * Matches the loaded card at both breakpoints: a 4:3 leading portrait on
 * mobile, then portrait + identity + availability columns from `sm`.
 */
export function TherapistCardSkeleton() {
  return (
    <div
      data-testid="therapist-card-skeleton"
      className="overflow-hidden rounded-2xl border border-border/70 bg-card shadow-[0_1px_2px_rgba(16,24,40,0.04)]"
    >
      <div className="grid sm:grid-cols-[11rem_1.15fr_1fr] md:grid-cols-[14rem_1.15fr_1fr] lg:grid-cols-[16rem_1.15fr_1fr]">
        <div className="p-4 pb-0 sm:hidden">
          <Skeleton className="aspect-4/3 w-full rounded-lg bg-editorial-quiet ring-8 ring-secondary" />
        </div>

        <div className="hidden sm:block sm:p-5 sm:pr-0">
          <Skeleton className="h-full min-h-64 w-full rounded-lg bg-editorial-quiet ring-8 ring-secondary" />
        </div>

        <div className="p-4 sm:border-r sm:border-border/60 sm:p-5">
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-3 w-24" />
          </div>

          {/* Spacing tuned so the three bars occupy the same height as three
              single-line bullets in the real card. */}
          <div className="mt-3.5 space-y-3 border-t border-border/60 pt-3.5">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-4 w-3/5" />
          </div>

          <div className="mt-3.5 border-t border-border/60 pt-3">
            <div className="flex items-center justify-between gap-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-5 w-14" />
            </div>
          </div>
        </div>

        <div className="border-t border-border/60 p-4 sm:border-t-0 sm:p-5">
          <Skeleton className="mx-auto h-4 w-48" />
          <div className="mt-3 grid grid-cols-4 gap-2">
            {/*
             * Same padding and same three lines as a real tile (weekday, date,
             * slot count) rather than one guessed height, so the grid keeps its
             * size when availability arrives.
             */}
            {Array.from({ length: 8 }, (_, index) => (
              <div key={index} className="rounded-lg bg-secondary px-1 py-1.5">
                <Skeleton className="mx-auto h-4 w-8" />
                <Skeleton className="mx-auto h-4 w-10" />
                <Skeleton className="mx-auto mt-0.5 h-3.75 w-12" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
